import React from "react";
import { Route, Redirect } from "react-router-dom";

const RedirectRoute = ({ children, ...props }) => (
  <Route
    render={() => (props.if ? children : <Redirect to={props.to} />)}
  ></Route>
);

export default RedirectRoute;
